export function modalAdd(productData) {
	const productCont = document.querySelector(".js-productCont");
	const productChild = document.getElementById("productInfo");

	if (productChild) {
		productChild.parentNode.removeChild(productChild);
	}

	productCont.insertAdjacentHTML(
		"beforeend",
		'<div id="productInfo" class="js-productChild"><div class="c-modalProduct_head"><div class="c-modalProduct_headInner"><div class="c-modalProduct_size">' +
		productData.cm +
		'</div><div class="c-modalProduct_heading"><p class="c-modalProduct_headingMain">' +
		productData.en +
		'</p><p class="c-modalProduct_headingSub">' +
		productData.jp +
		'</p></div></div><div class="c-modalProduct_price">¥<span>' +
		productData.price +
		'</span>+tax</div></div><div class="c-modalProduct_view"><p class="c-modalProduct_img ' + productData.rotateClass + '"><img src="' +
		productData.img + '" alt="" /></p><div class="c-modalProduct_info"><p class="c-modalProduct_infoName">サイズ詳細</p><div class="c-modalProduct_detailCont"><div class="c-modalProduct_detailBox"><dl class="c-modalProduct_detail"><dt class="c-modalProduct_detailHead">サイズ</dt><dd class="c-modalProduct_detailBody">' +
		productData.size +
		'</dd></dl><dl class="c-modalProduct_detail ' + productData.class + ' "><dt class="c-modalProduct_detailHead">容量</dt><dd class="c-modalProduct_detailBody">' +
		productData.capacity +
		'</dd></dl><dl class="c-modalProduct_detail ' + productData.class + ' "><dt class="c-modalProduct_detailHead">目安量</dt><dd class="c-modalProduct_detailBody">' +
		productData.amount +
		'</dd></dl><dl class="c-modalProduct_detail"><dt class="c-modalProduct_detailHead">' +
		productData.diameterText +
		'</dt><dd class="c-modalProduct_detailBody">' +
		productData.diameter +
		'</dd></dl><dl class="c-modalProduct_detail"><dt class="c-modalProduct_detailHead">横※</dt><dd class="c-modalProduct_detailBody">' +
		productData.width +
		'</dd></dl><dl class="c-modalProduct_detail"><dt class="c-modalProduct_detailHead">高さ※</dt><dd class="c-modalProduct_detailBody">' +
		productData.height +
		'</dd></dl></div><div class="c-modalProduct_detailBox"><dl class="c-modalProduct_detail"><dt class="c-modalProduct_detailHead">重量</dt><dd class="c-modalProduct_detailBody">' +
		productData.weight +
		'</dd></dl><dl class="c-modalProduct_detail"><dt class="c-modalProduct_detailHead">底厚</dt><dd class="c-modalProduct_detailBody">' +
		productData.bottom +
		'</dd></dl><dl class="c-modalProduct_detail"><dt class="c-modalProduct_detailHead">緑厚</dt><dd class="c-modalProduct_detailBody">' +
		productData.edge +
		'</dd></dl><dl class="c-modalProduct_detail"><dt class="c-modalProduct_detailHead">品番</dt><dd class="c-modalProduct_detailBody">' +
		productData.number +
		'</dd></dl></div></div><p class="c-modalProduct_note">' +
		productData.note +
		'</p></div></div><div class="c-modalProduct_cont"><div class="c-modalProduct_box"><ul class="c-modalProduct_link"><li class="c-modalProduct_linkList"><a href="' +
		productData.shop01 +
		'" class="c-bnr_link c-bnr_link--product c-bnr_link--red" target="_blank">LAVAショップ 楽天市場店</a></li><li class="c-modalProduct_linkList"><a href="' +
		productData.shop02 +
		'" class="c-bnr_link c-bnr_link--product c-bnr_link--pink" target="_blank">LAVAショップ Yahoo!ショッピング店</a></li></ul></div><div class="c-modalProduct_pic"><img src="' +
		productData.sizeImg +
		'" alt=""/></div></div></div>'
	);
}